var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(_vm.isExporting)?_c('img',{attrs:{"src":_vm.image,"alt":"Widget"}}):_vm._e(),_c('div',{ref:"container",staticClass:"chart-container",class:{ 'am5-exporting': _vm.isExporting }},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }